enum GROW2529_ACTIONS {
  FORMS_TOGGLE_SWITCH = 'FORMS_TOGGLE_SWITCH',
  FORMS_RESET_TOGGLE_SWITCH = 'FORMS_RESET_TOGGLE_SWITCH',
}

export default GROW2529_ACTIONS;
